var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Done.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Done = ({
  color = '#fff',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M4.50006 8.49961L1.58339 5.58294C1.25839 5.25794 0.741724 5.25794 0.416724 5.58294C0.0917236 5.90794 0.0917236 6.42461 0.416724 6.74961L3.90839 10.2413C4.23339 10.5663 4.75839 10.5663 5.08339 10.2413L13.9167 1.41628C14.2417 1.09128 14.2417 0.574609 13.9167 0.249609C13.5917 -0.0753906 13.0751 -0.0753906 12.7501 0.249609L4.50006 8.49961Z",
    fill: color
  })
});